module.exports = __webpack_public_path__ + "media/icons/slider-point@2x-c969fb60.png";